import { combineSlices } from "@reduxjs/toolkit";

import { addInAuthSlice } from "./authentication/addInAuthSlice";
import { currentDocumentSlice } from "./currentDocument/currentDocumentSlice";
import { entitiesSlice } from "./entities/entitiesSlice";
import { metadataSlice } from "./metadata/metadataSlice";

export default combineSlices(
  addInAuthSlice,
  currentDocumentSlice,
  entitiesSlice,
  metadataSlice
);
